<app-header headerText="Parámetros Préstamo Caja De Ahorro Permanente"></app-header>

<mat-tab-group mat-align-tabs="center" animationDuration="0ms" dynamicHeight=true [selectedIndex]="selectedIndex">

  <mat-tab>

    <ng-template mat-tab-label>
      <mat-icon>edit</mat-icon>
      Editar<br>Ciclo
    </ng-template>

    <div class="row py-2 border-bottom">

      <div class="col-md-4 offset-md-4">

        <mat-form-field>
          <mat-select placeholder="Nombre del Ciclo de Ahorro a Editar:"
            (selectionChange)="selectedPeriodChange($event)" [value]="tempPeriod">
            <mat-option>Seleccione el ciclo</mat-option>
            <mat-option *ngFor="let period of savingParameters" [value]="period">
              {{period.title}}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>

    </div>

    <div *ngIf="modParameter">

      <div *ngIf="!newLoanParameter && modParameter.loansParameters">

        <div class="row mt-5">
          <div class="col-md-12 bottom-vertically">
            <button class="btn-block" mat-raised-button color="primary" (click)="addSeniorityRange()">Añadir</button>
          </div>
        </div>

        <div class="row">

          <div class="col-md-12">

            <mat-table #rangeTable class="table" [dataSource]="modParameter.loansParameters">

              <ng-container matColumnDef="start">
                <mat-header-cell mat-header-cell *matHeaderCellDef> Desde Año </mat-header-cell>
                <mat-cell mat-cell *matCellDef="let element"> {{element.applicableSeniorityRange.start}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="end">
                <mat-header-cell mat-header-cell *matHeaderCellDef> Hasta Año </mat-header-cell>
                <mat-cell mat-cell *matCellDef="let element"> {{element.applicableSeniorityRange.end}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="edit" class="center-text">
                <mat-header-cell *matHeaderCellDef><span>Editar</span></mat-header-cell>
                <mat-cell *matCellDef="let index = index">
                  <button mat-icon-button color="primary" (click)="editLoanParameter(index)">
                    <mat-icon aria-label="Edit">edit_outline</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="delete" class="center-text">
                <mat-header-cell *matHeaderCellDef><span>Eliminar</span></mat-header-cell>
                <mat-cell *matCellDef="let index = index">
                  <button mat-icon-button color="warn" (click)="deleteLoanParameter(index)">
                    <mat-icon aria-label="Delete">delete_outline</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>

              <mat-header-row mat-header-row *matHeaderRowDef="seniorityRangeColumns"></mat-header-row>
              <mat-row mat-row *matRowDef="let row; columns: seniorityRangeColumns;"></mat-row>
            </mat-table>

          </div>

        </div>

      </div>

      <div *ngIf="newLoanParameter">

        <div class="row py-5 border-bottom" [ngClass]="{'blocked': !isEdit}">

          <div class="col-md-6 mt-2 col-xl-3 mt-xl-0">
            <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 0"
              [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 0" (click)="switchTo(0)">
              Antigüedad De<br>Colaborador
            </button>
          </div>

          <div class="col-md-6 col-xl-3">
            <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 1"
              [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 1" (click)="switchTo(1)">
              Monto y Porcentajes<br> De Préstamo
            </button>
          </div>

          <div class="col-md-6 mt-2 col-xl-3 mt-xl-0">
            <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 2"
              [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 2" (click)="switchTo(2)">
              Fechas<br>De Ciclo
            </button>
          </div>

          <div class="col-md-6 mt-2 col-xl-3 mt-xl-0">
            <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 3"
              [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 3" (click)="switchTo(3)">
              Recuperación De<br>Préstamos
            </button>
          </div>


        </div>

        <div *ngIf="contentLocation.savingParametersIndex == 0" [ngClass]="{'blocked': !isEdit}">

          <div class="row pt-5">

            <div class="col-md-4">
              <mat-form-field>
                <input matInput placeholder="Inicio (En Años):" type="number"
                  [(ngModel)]="newLoanParameter.applicableSeniorityRange.start" #weeksControl="ngModel" min="0"
                  [min]="0" [max]="100000" onkeypress="return event.charCode >= 48 && event.charCode <= 57" required>
                <mat-error *ngIf="weeksControl?.errors?.required">Es necesario especificar el número de años.
                </mat-error>
                <mat-error *ngIf="weeksControl?.errors?.min">El número de años debe de ser mayor a -1.</mat-error>
                <mat-error *ngIf="weeksControl?.errors?.max">El número de años debe de ser menor a 100000.</mat-error>
              </mat-form-field>
            </div>

            <div class="col-md-4">
              <mat-form-field>
                <input matInput placeholder="Fin (En Años):" type="number"
                  [(ngModel)]="newLoanParameter.applicableSeniorityRange.end" #biWeeksControl="ngModel" min="1"
                  [min]="1" [max]="100000" onkeypress="return event.charCode >= 48 && event.charCode <= 57" required>
                <mat-error *ngIf="biWeeksControl?.errors?.required">Es necesario especificar el número de catorcenas.
                </mat-error>
                <mat-error *ngIf="biWeeksControl?.errors?.min">El número de años debe de ser mayor a 1.</mat-error>
                <mat-error *ngIf="biWeeksControl?.errors?.max">El número de años debe de ser menor a 100000.</mat-error>
              </mat-form-field>
            </div>

          </div>

        </div>

        <div *ngIf="contentLocation.savingParametersIndex == 1" [ngClass]="{'blocked': !isEdit}">

          <div class="row mt-5">
            <div class="col-md-4">

              <mat-form-field>
                <input matInput placeholder="Meses Sueldo a Solicitar:" type="number"
                  [(ngModel)]="newLoanParameter.maxEmployeeWageLoan" min="1" [min]="1"
                  #maxEmployeeWageLoanControl="ngModel"
                  onkeypress="return event.charCode >= 46 && event.charCode <= 57 && event.charCode != 47" required>
                <mat-error *ngIf="maxEmployeeWageLoanControl?.errors?.required">Es necesario especificar el número de
                  meses.
                </mat-error>
                <mat-error *ngIf="maxEmployeeWageLoanControl?.errors?.min">Como mínimo se debe de especificar 1 mes.
                </mat-error>
              </mat-form-field>

            </div>
          </div>

          <div class="row">

            <div class="col-md-4">
              <mat-form-field>
                <input matInput placeholder="Porcentaje Semana Ahorrador:" type="number"
                  [(ngModel)]="newLoanParameter.weeklySavingInterestsRate" min="0.0001" max="1" [min]="0.0001" [max]="1"
                  #weeklySavingInterestsRateControl="ngModel" step="0.0001" required>
                <mat-error *ngIf="weeklySavingInterestsRateControl?.errors?.required">Es necesario especificar el
                  interés
                  semanal.</mat-error>
                <mat-error *ngIf="weeklySavingInterestsRateControl?.errors?.min">El número debe de ser mayor a 0.0001 .
                </mat-error>
                <mat-error *ngIf="weeklySavingInterestsRateControl?.errors?.max">El número debe de ser menor al 1 .
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-md-4">
              <mat-form-field>
                <input matInput placeholder="Porcentaje Semana No Ahorrador:" type="number"
                  [(ngModel)]="newLoanParameter.weeklyNonSavingInterestsRate" min="0.0001" max="1" [min]="0.0001"
                  [max]="1" #weeklyNonSavingInterestsRateControl="ngModel" step="0.0001" required>
                <mat-error *ngIf="weeklyNonSavingInterestsRateControl?.errors?.required">Es necesario especificar el
                  interés
                  semanal.</mat-error>
                <mat-error *ngIf="weeklyNonSavingInterestsRateControl?.errors?.min">El número debe de ser mayor a 0.0001
                  .
                </mat-error>
                <mat-error *ngIf="weeklyNonSavingInterestsRateControl?.errors?.max">El número debe de ser menor al 1.
                </mat-error>
              </mat-form-field>
            </div>

          </div>

          <div class="row mb-5">

            <div class="col-md-4">
              <mat-form-field>
                <input matInput placeholder="Porcentaje Catorcena Ahorrador:" type="number"
                  [(ngModel)]="newLoanParameter.biWeeklySavingInterestsRate" min="0.0001" max="1" [min]="0.0001"
                  [max]="1" #biWeeklySavingInterestsRateControl="ngModel" step="0.0001" required>
                <mat-error *ngIf="biWeeklySavingInterestsRateControl?.errors?.required">Es necesario especificar el
                  interés
                  catorcena.</mat-error>
                <mat-error *ngIf="biWeeklySavingInterestsRateControl?.errors?.min">El número debe de ser mayor a 0.0001
                  .
                </mat-error>
                <mat-error *ngIf="biWeeklySavingInterestsRateControl?.errors?.max">El número debe de ser menor al 1.
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-md-4">
              <mat-form-field>
                <input matInput placeholder="Porcentaje Catorcena No Ahorrador:" type="number"
                  [(ngModel)]="newLoanParameter.biWeeklyNonSavingInterestsRate" min="0.0001" max="1" [min]="0.0001"
                  [max]="1" #biWeeklyNonSavingInterestsRateControl="ngModel" step="0.0001" required>
                <mat-error *ngIf="biWeeklyNonSavingInterestsRateControl?.errors?.required">Es necesario especificar el
                  interés catorcena.</mat-error>
                <mat-error *ngIf="biWeeklyNonSavingInterestsRateControl?.errors?.min">El número debe de ser mayor a
                  0.0001
                  .
                </mat-error>
                <mat-error *ngIf="biWeeklyNonSavingInterestsRateControl?.errors?.max">El número debe de ser menor al 1.
                </mat-error>
              </mat-form-field>
            </div>

          </div>

          <div class="row border-top pt-5">

            <div class="col-md-4 center-vertically">
              <mat-checkbox [(ngModel)]="newLoanParameter.extraLoanAllowed" (change)="onChange()"
                labelPosition="before">
                Activar el Ahorro Acumulado</mat-checkbox>
            </div>

            <div class="col-md-4">

              <mat-form-field class="example-full-width">
                <input matInput placeholder="% Acumulado Ahorro Caja Permanente:" min="0" max="100" [min]="1"
                  [max]="100" type="number" [(ngModel)]="newLoanParameter.extraLoanPercentage" min="0"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57" #extraLoanPercentage="ngModel">

                <mat-error *ngIf="extraLoanPercentage?.errors?.min">La cantidad debe de ser mayor a 1.</mat-error>
                <mat-error *ngIf="extraLoanPercentage?.errors?.max">La cantidad debe de ser menor a 100 %.</mat-error>

              </mat-form-field>

            </div>

          </div>

          <div class="row">

            <div class="col-md-4 center-vertically">
              <mat-checkbox [(ngModel)]="newLoanParameter.extraLoanFALPAllowed" (change)="onChangeFalp()"
                labelPosition="before">Activar
                Acumulado FALP</mat-checkbox>
            </div>

            <div class="col-md-4">

              <mat-form-field class="example-full-width">
                <input matInput placeholder="% Acumulado FALP:" type="number" min="0" max="100" [min]="1" [max]="100"
                  [(ngModel)]="newLoanParameter.extraLoanFALPPercentage"
                  [readonly]="!newLoanParameter.extraLoanFALPAllowed" #extraLoanFALPPercentage="ngModel"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57">

                <mat-error *ngIf="extraLoanFALPPercentage?.errors?.min">La cantidad debe de ser mayor a 1.</mat-error>
                <mat-error *ngIf="extraLoanFALPPercentage?.errors?.max">La cantidad debe de ser menor a 100 %.
                </mat-error>

              </mat-form-field>

            </div>

          </div>

        </div>

        <div *ngIf="contentLocation.savingParametersIndex == 2" [ngClass]="{'blocked': !isEdit}">

          <div class="row my-5">

            <div class="col-md-4">
              <mat-form-field>
                <input matInput [matDatepicker]="inicioDeCicloActivoPicker" placeholder="Inicio De Préstamo:"
                  (dateChange)="setRegistrationDate('starts', $event)" [value]="newRLoanDate.startDate">
                <mat-datepicker-toggle matSuffix [for]="inicioDeCicloActivoPicker"></mat-datepicker-toggle>
                <mat-datepicker #inicioDeCicloActivoPicker></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-md-4">
              <mat-form-field>
                <input matInput [matDatepicker]="finDeCicloActivePicker" placeholder="Fin De Préstamo:"
                  (dateChange)="setRegistrationDate('ends', $event)" [value]="newRLoanDate.endDate"
                  [min]="newRLoanDate.startDate" [disabled]="!newRLoanDate.startDate">
                <mat-datepicker-toggle matSuffix [for]="finDeCicloActivePicker"></mat-datepicker-toggle>
                <mat-datepicker #finDeCicloActivePicker [disabled]="!newRLoanDate.startDate"></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-md-4 bottom-vertically">
              <button class="btn-block" mat-raised-button color="primary" (click)="addDate()">Añadir</button>
            </div>

          </div>

          <div class="my-5 row border-top" *ngIf="newLoanParameter.loanDates.length > 0">
            <div class="col-md-12">

              <mat-table #loanDatesTable class="table" [dataSource]="newLoanParameter.loanDates">

                <ng-container matColumnDef="InicioPrestamo">
                  <mat-header-cell *matHeaderCellDef> Inicio De Préstamo</mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.startDate | date: 'mediumDate'}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="FinPrestamo">
                  <mat-header-cell *matHeaderCellDef> Fin De Préstamo </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.endDate ? (element.endDate | date: 'mediumDate') :
                    ''}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="active">
                  <mat-header-cell *matHeaderCellDef> Fecha Activa </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <mat-checkbox [(ngModel)]="element.active" [disabled]="false">Fecha Activa</mat-checkbox>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="delete" class="center-text">
                  <mat-header-cell *matHeaderCellDef><span>Eliminar</span></mat-header-cell>
                  <mat-cell *matCellDef="let index = index">
                    <button mat-icon-button color="warn" (click)="deleteLoanDate(index)">
                      <mat-icon aria-label="Delete">delete_outline</mat-icon>
                    </button>

                  </mat-cell>
                </ng-container>

                <mat-header-row mat-header-row *matHeaderRowDef="displayedLoanDatesColumns"></mat-header-row>
                <mat-row mat-row *matRowDef="let row; columns: displayedLoanDatesColumns;"></mat-row>

              </mat-table>

            </div>
          </div>

        </div>

        <div *ngIf="contentLocation.savingParametersIndex == 3" [ngClass]="{'blocked': !isEdit}">

          <div class="row mt-5">

            <div class="col-md-12">

              <mat-table #installmentsTable class="table"
                [dataSource]="logicService.dataManager.parameterDataLoader.installments">

                <ng-container matColumnDef="installmentID">
                  <mat-header-cell mat-header-cell *matHeaderCellDef> ID </mat-header-cell>
                  <mat-cell mat-cell *matCellDef="let element"> {{element.installmentID}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="weeks">
                  <mat-header-cell mat-header-cell *matHeaderCellDef> Semana(s) </mat-header-cell>
                  <mat-cell mat-cell *matCellDef="let element"> {{element.weeks}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="biWeeks">
                  <mat-header-cell mat-header-cell *matHeaderCellDef> Catorcena(s) </mat-header-cell>
                  <mat-cell mat-cell *matCellDef="let element"> {{element.biWeeks}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="months">
                  <mat-header-cell mat-header-cell *matHeaderCellDef> Mes(es) </mat-header-cell>
                  <mat-cell mat-cell *matCellDef="let element"> {{element.months}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="select">
                  <mat-header-cell mat-header-cell *matHeaderCellDef>
                    Selección
                  </mat-header-cell>
                  <mat-cell mat-cell *matCellDef="let row">
                    <mat-radio-button (click)="$event.stopPropagation()"
                      (change)="$event ? selectionInstallments.toggle(row) : null"
                      [checked]="selectionInstallments.isSelected(row)"></mat-radio-button>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="delete" class="center-text">
                  <mat-header-cell *matHeaderCellDef><span>Eliminar</span></mat-header-cell>
                  <mat-cell *matCellDef="let index = index">
                    <button mat-icon-button color="warn" (click)="deleteInstallments(index)">
                      <mat-icon aria-label="Delete">delete_outline</mat-icon>
                    </button>
                  </mat-cell>
                </ng-container>

                <mat-header-row mat-header-row *matHeaderRowDef="displayedInstallmentsColumns"></mat-header-row>
                <mat-row mat-row *matRowDef="let row; columns: displayedInstallmentsColumns;"></mat-row>
              </mat-table>

            </div>

          </div>
          <div class="row mt-5">
            <div class="col-md-3 mt-4 ml-5">
              <mat-checkbox [checked]="isEndDate" (change)="activateEndDate($event.checked)" [disabled]="existDate">
                Agregar Fecha Límite
              </mat-checkbox>
            </div>
            <div class="col-md-3 mr-5">
              <mat-form-field >
                <input [(ngModel)]="dateMaxPayments" placeholder="Fecha Límite:" [disabled]="!isEndDate" matInput
                  [matDatepicker]="alternateInput">
                <mat-datepicker-toggle matSuffix [for]="alternateInput"></mat-datepicker-toggle>
                <mat-datepicker #alternateInput></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-md-3 mt-4 ml-5">
             <label>{{dateMaxPayments | date}} </label> 
            </div>
            <div class="col-md-1" *ngIf="existDate" >
              <button mat-icon-button color="warn" (click)="deleteDateLoan(dateMaxPayments)">
                <mat-icon aria-label="Delete">delete_outline</mat-icon>
              </button>
            </div>

          </div>


        </div>

        <div class="row my-4" [ngClass]="{'blocked': !isEdit}">

          <div class="col-md-4 offset-md-4">
            <button class="btn btn-block btn-outline-secondary" (click)="cancelPeriodChanges()">Cancelar</button>
          </div>

          <div class="col-md-4">
            <button class="btn btn-block btn-primary" (click)="saveEditedPeriod();">Guardar Cambios</button>
          </div>

        </div>

      </div>

    </div>

  </mat-tab>

</mat-tab-group>